export default "__VITE_ASSET__BcLmTrNT__"